<template>
  <div class="kanban-column" :style="getCotacoesCardStyle()">
    <div class="kanban-column-title">
      <span class="left">{{ title }}</span>
      <span class="right">{{ cotacoes.length }}</span>
    </div>
    <cotacoes-card
      v-for="(item, index) in cotacoes"
      :key="index"
      :id="item.id"
      :status="item.status"
      :type="item.type"
      :value="item.value"
      :name="item.name"
      :expires-in="item.expiresIn ? item.expiresIn : false"
      :title="item.title"
      :wait-time="item.waitTime ? item.waitTime : false"
      :finished="item.finished ? item.finished : false"
      :color="grabNotificationColorByStatus(item.status)"
      :remove-border-left="removeBorderLeft"
      :remove-border-right="removeBorderRight"
      :action-right-text="getActionRightText(item)"
    ></cotacoes-card>
  </div>
</template>
<script lang="js">
export default {
  name: "NotificacoesColumn",
  methods: {
    grabColorByType(type) {
      let color = "";
      switch (type) {
        case "COTACAO":
          color = "#FF9700";
          break;

        case "PROPOSTA":
          color = "#7ED321";
          break;

        case "PROPOSTA_ENVIADAS":
          color = "#4589F3";
          break;
      }

      return color;
    },

    grabNotificationColorByStatus(type) {
      let color = "";
      switch (type) {
        case "PERDA_TOMADORES_NOMEADOS":
          color = "#F5A623";
          break;

        case "APOLICES_VENCER":
          color = "#4589F3";
          break;

        case "ATUALIZAR_INF":
          color = "#FF9700";
          break;

        case "BOLETOS_VENCIDOS":
          color = "#F81C50";
          break;
      }

      return color;
    },
    getCotacoesCardStyle() {
      let style = [];
      let t = this;
      style.push({ borderBottom: "2px solid" + t.color });
      if (t.removeBorderLeft) {
        style.push({ borderLeft: "none" });
      }
      if (t.removeBorderRight) {
        style.push({ borderRight: "none" });
      }
      return style;
    },
    getActionRightText(item) {
      let t = this;
      if (item.expiresIn) {
        return (
          "Expira - " +
          item.expiresIn +
          " dia" +
          (item.expiresIn > 1 ? "s" : "")
        );
      }
      if (item.waitTime) {
        return (
          "Espera - " + item.waitTime + " dia" + (item.waitTime > 1 ? "s" : "")
        );
      }
      if (item.finished) {
        return this.$moment(item.finished).format("DD/MM/YYYY");
      }
    },
  },
  props: ["cotacoes", "title", "removeBorderLeft", "removeBorderRight"],
};
</script>
<style lang="scss" scoped>
.kanban-column-title {
  height: 43px;
  padding-left: 10px;
  padding-right: 10px;
  border-top: 1px solid #cbcbcb;
  border-bottom: 1px solid #cbcbcb;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  line-height: 43px;
  color: #35343d;
  font-weight: bold;
  .right {
    color: #979797;
    font-size: 16px;
  }
}
.kanban-column {
  border: 1px solid #cbcbcb;
  border-top: none;
  display: flex;
  flex-direction: column;
  height: calc(100%);
}
</style>



// WEBPACK FOOTER //
// ./src/components/NotificacoesColumn.vue